import React, {useEffect, useState} from "react";
import NoDataContent from "../../../../../../components/reports/report-menu/no-data-content.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import projectUtils from "../../../../../../utils/project-utils.js";

const INITIAL_LIMIT = 10;
const reportId = "dispatches-by-address"
const reportName = "Despachos por endereço"
const DispatchesByAddress = ({data}) => {
  const [limit, setLimit] = useState(INITIAL_LIMIT);

  useEffect(() => {
    const headers = ["Quantidade", "Logradouro", "Bairro"];
    const rows = data.map(item => [
      item.qty,
      item.street_name,
      item.neighborhood_name
    ]);

    data?.length &&  ReportUtils.createExportableTable(headers, rows, reportName);
  }, [data]);

  const seeMoreOrLess = () => {
    setLimit(prev => prev ? null : INITIAL_LIMIT);
  };

  return(
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName} {(data.length > limit && limit) ? ` (TOP ${INITIAL_LIMIT})` : ''}</span>
      </div>
      {
        data.length > 0
        ?<div className="mt-3 mb-3">
            <table id={reportId} className="table report-table" sheet-name={reportName}>
              <thead className="thead-background print:table-row-group!">
              <tr className="bg-[#f6f6f6] text-left">
                <th className="w-[10%]">Quantidade</th>
                <th>Logradouro</th>
                <th>Bairro</th>
              </tr>
              </thead>
              <tbody>
              {(!!limit ? data.slice(0, limit) : data).map((el, index) => (
                <React.Fragment key={index}>
                  <tr className={`table-break-word`}>
                    <td className="w-[10%]">{el.qty}</td>
                    <td>{el.street_name}</td>
                    <td>{el.neighborhood_name}</td>
                  </tr>
                </React.Fragment>
              ))}
              </tbody>
            </table>
            { data.length > INITIAL_LIMIT &&
              <div className="w-full flex justify-end gap-2 print-hide">
              <span className="see-more print-hide" onClick={seeMoreOrLess}>
                { limit ? "Ver mais" : "Ver menos"}
              </span>
              </div>
            }
         </div>
          : <div className="mt-1"><NoDataContent reportData={true} data={0}/></div>
      }
      <div className="chart-divisor"></div>
    </>
  )
}

export default DispatchesByAddress;